module.exports = __webpack_public_path__ + "static/media/vinglabs_noesis_2.e1c06e3c.gif";